<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

/**
 * Primary site navigation.
 * Renders an array of {label, to} entries as <RouterLink> items styled with
 * legacy .main-nav classes. is-active is applied automatically by RouterLink.
 */
export interface NavItem {
  label: string;
  to: RouteLocationRaw;
  /** Optional exact-match flag (default true for root, false otherwise). */
  exact?: boolean;
}

defineProps<{ items: NavItem[] }>();
</script>

<template>
  <nav
    class="main-nav"
    aria-label="Главная навигация"
  >
    <RouterLink
      v-for="item in items"
      :key="item.label"
      :to="item.to"
      class="main-nav__item"
      active-class="is-active"
      :exact-active-class="item.exact !== false ? 'is-active' : undefined"
    >
      {{ item.label }}
    </RouterLink>
  </nav>
</template>
